import { Component, Input } from '@angular/core';

export interface Faq {
  question: string;
  answer: string;
  excludeIn?: string[];
}
export interface TranslatedFAQ {
  question: () => string;
  question2?: () => string;
  answer: () => string;
  excludeIn: () => string;
}

@Component({
  selector: 'app-faqs-section',
  templateUrl: './component.html',
  styleUrls: ['./component.scss'],
})

export class FaqsSectionComponent {
  @Input() faqs: Faq[];
}
